export class InvitePersonModel {
    personHashId: string;
    userName: string;

}

export class AdminInvitationModel {
    public emailAddress: string;
    public personHashId: string;
    public roleHashIdList: string[];
}

export class CustomerAdminInvitationModel extends AdminInvitationModel {
    public customerHashId: string;
}

export class InstanceAdminInvitationModel extends AdminInvitationModel {
    public instanceHashId: string;
}

export class CompanyAdminInvitationModel extends AdminInvitationModel {
    public companyHashId: string;
}

export class SharedVehicleGroupAdminInvitationModel extends AdminInvitationModel {
    public sharedVehicleGroupHashId: string;
}

export class OrganizationAdminInvitationModel extends AdminInvitationModel {
    public organizationHashId: string;
}

export class OrganizationDriverInvitationModel extends AdminInvitationModel {
    public organizationHashId: string;
    public userName:string;
    public rfidTagId: string
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-invite-popup/models/admin-to-invite.model.ts